import { useCallback } from 'react'
import { useTranslate } from 'shared/lib/i18n'

/**
 * A label read through the i18n lookup, falling back to the raw code when the
 * key is not translated yet. This is what lets a kind added to the backend's
 * catalogue (tickets 06, 08, 09, 11) appear in the list before anyone adds its
 * Russian name: the row shows the code, never an empty badge. Stable while the
 * language is, so a table's columns built over it stay memoized.
 */
export function useLabel() {
	const { t } = useTranslate()
	return useCallback((key: string, fallback: string) => t(key as never) || fallback, [t])
}
